import { render, staticRenderFns } from "./indexBarItem.vue?vue&type=template&id=7d4528ce&scoped=true&"
import script from "./indexBarItem.vue?vue&type=script&lang=js&"
export * from "./indexBarItem.vue?vue&type=script&lang=js&"
import style0 from "./indexBarItem.vue?vue&type=style&index=0&id=7d4528ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4528ce",
  null
  
)

export default component.exports